import "./styles.less";
import "./stylesFincaraiz.less";

import { Col, Row, Skeleton, Typography } from "antd";
import { useContext } from "react";

import { News } from "./News/web";
import { NewsCardFincaraiz } from "./News/NewsCardFincaraiz";
import { useNewsSection } from "./NewsSection.hook";
import { useFincaraizNewsSection } from "./FincaraizNewsSection.hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { getNoticiasBlogLink } from "./FincaraizNewsSection.links";

const { Title } = Typography;

export function NewsSection() {
	const { country_code } = useContext(ConfigStateContext);

	if (country_code === "CO") {
		return <FincaraizNewsSection />;
	}

	return <DefaultNewsSection />;
}

const FincaraizNewsSection = () => {
	const { loading, slots, hasAllPosts } = useFincaraizNewsSection();
	const { theme } = useTheme();
	const { header_links } = useContext(ConfigStateContext);
	const noticiasBlogLink = getNoticiasBlogLink(header_links);

	if (loading) return <FincaraizNewsSkeleton />;
	if (!hasAllPosts) return null;

	return (
		<div className="news-section news-section-fincaraiz">
			<div className="news-section-fincaraiz__header">
				<div className="news-section-fincaraiz__header-text">
					<span className="news-section-fincaraiz__eyebrow">— BLOG FINCARAÍZ</span>
					<h2 className="news-section-fincaraiz__title">Actualidad y análisis del sector inmobiliario</h2>
					<p className="news-section-fincaraiz__subtitle">
					Explora las noticias, nuestros informes y consejos para conocer mejor el mercado.
					</p>
				</div>
				<a
					className="news-section-fincaraiz__view-all"
					href={noticiasBlogLink}
					target="_blank"
					rel="noopener noreferrer">
					Ver todo el contenido →
				</a>
			</div>

			<Row gutter={[theme.spacing.xlSpacing, theme.spacing.xlSpacing]}>
				{slots.map(({ category, post }) => (
					<Col xs={24} md={8} key={category.slug}>
						<NewsCardFincaraiz
							news={post!}
							category={category}
							blogBaseUrl={noticiasBlogLink}
						/>
					</Col>
				))}
			</Row>
		</div>
	);
};

const DefaultNewsSection = () => {
	const { data, loading, error } = useNewsSection({ first: 4, home: true });
	const { theme } = useTheme();

	if (loading) return <NewSectionsSkeleton />;
	if (error) return null;
	if (data && data?.data?.length < 4) return null;

	const BigNews = data?.data[0];
	const Small = data?.data.slice(1, 4);

	return (
		<div className="news-section">
			<Row gutter={theme.spacing.xxlSpacing}>
				<Col xs={24} md={14}>
					<News news={BigNews} size={"large"} key={"newsLarge_" + BigNews.id} />
				</Col>
				<Col xs={24} md={10}>
					<div className="recommended">
						<Title className="title" level={3} type="secondary">
							{"Recomendado"}
						</Title>
					</div>
					{Small.map(news => (
						<News news={news} key={"newsSmall_" + news.id} />
					))}
				</Col>
			</Row>
		</div>
	);
};

const FincaraizNewsSkeleton = () => {
	const { theme } = useTheme();

	return (
		<div className="news-section news-section-fincaraiz">
			<div className="news-section-fincaraiz__header">
				<Skeleton active paragraph={{ rows: 2 }} title={{ width: "60%" }} />
			</div>
			<Row gutter={[theme.spacing.xlSpacing, theme.spacing.xlSpacing]}>
				{[1, 2, 3].map(item => (
					<Col xs={24} md={8} key={item}>
						<Skeleton.Image className="news-card-fincaraiz-skeleton__image" active />
						<Skeleton active paragraph={{ rows: 3 }} />
					</Col>
				))}
			</Row>
		</div>
	);
};

const NewSectionsSkeleton = () => {
	const { theme } = useTheme();

	return (
		<Row gutter={theme.spacing.xxlSpacing}>
			<Col xs={24} md={14}>
				<Row>
					<Col span={24}>
						<Skeleton.Image className={"image-new-large-skeleton"} />
					</Col>
					<Col span={24}>
						<Skeleton active />
					</Col>
				</Row>
			</Col>
			<Col xs={24} md={10}>
				{[1, 2, 3].map(news => (
					<Row key={news}>
						<Col span={12}>
							<Skeleton active />
						</Col>
						<Col span={12}>
							<Skeleton.Image className={"image-new-small-skeleton"} />
						</Col>
					</Row>
				))}
			</Col>
		</Row>
	);
};
